import {post,get} from '../../libs/ajax.js';

export default {

    // 获取页面权限
    getPageAllowAction: (data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/get_page_allow_action', data, options)
    },

    // 任务列表-列表数据
    getTaskList:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/list', data, options);
    },
    // 任务列表 - 获取发送状态
    getTaskSendStatus:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/getSendStatus', data, options);
    },
    // 任务列表- 获取搜索下拉列表
    getSearchOptions:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/search_list', data, options);
    },
    // 任务列表-获取模板下拉列表
    getSearchTemplateList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/template/getSearchTemplateList', data, options);
    },
    // 任务列表-获取日报归属人下拉列表
    getUserOptions:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/select_user', data, options);
    },
    // 任务列表-获取日报归属部门下拉列表
    getGroupOptions:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/select_group', data, options);
    },
    // 任务列表-生成任务
    genTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/gen', data, options);
    },
    // 任务列表-发送任务预览
    getTaskMailInfo:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_email/get', data, options);
    },
    // 任务列表-发送任务
    sendTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/daily_task_email/send', data, options);
    },
    // 任务列表-批量发送
    batchSendTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/daily_task_email/batch_send', data, options);
    },
    // 任务列表-修改定时生成状态
    changeTaskStatus:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/change', data, options);
    },
    // 任务列表-修改自动发送开关
    changeTaskAutoSend:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/change/auto_send', data, options);
    },
    // 任务列表-任务生成-验证文件权限(生成前的权限校验)
    checkTaskPerm:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/check_detail_perm', data, options);
    },

    // 任务列表-删除任务
    deleteTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/del', data, options);
    },
    // 任务列表-调整任务位置
    setTaskPos:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/pos', data, options);
    },
    // 任务列表-置顶/取消置顶
    setTaskTop:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/daily_task/top/set', data, options);
    },
    // 任务列表-获取转让接收人列表
    getPushUserList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/get_user_list', data, options);
    },
    // 任务列表-转让日报
    pushTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/daily_task/push', data, options);
    },

    // 添加文件-模板列表
    getPlatTemplateList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/template/getPlatTemplateList', data, options);
    },
    // 添加文件-通过app获取账户列表
    getAppCompanyList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/get_company_list', data, options);
    },
    // 添加文件-通过账户获取app列表
    getCompanyAppList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/get_app_list', data, options);
    },
    // 添加文件-获取客户列表
    getCustomerList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/get_customer_list', data, options);
    },
    // 新建任务-检查任务名称
    checkTaskName:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/check_task_name_exist', data, options);
    },
    // 新建任务-保存任务
    saveDailyTask:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/daily_task/save', data, options);
    },
    // 编辑任务-获取任务详情信息
    getTaskInfo:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task/get', data, options);
    },

    // 任务详情列表-列表
    getTaskDetailList:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_detail/list', data, options);
    },
    // 任务详情列表-修改状态开关
    changeTaskDetailStatus:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_detail/change', data, options);
    },
    // 任务详情列表-生成
    genTaskDetail:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_detail/gen', data, options);
    },
    // 任务详情列表-检查下载
    checkDetailDownload:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_detail_record/downloadCheck', data, options);
    },
    // 任务详情列表-下载
    detailDownload:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_detail_record/download', data, options);
    },
    // 任务详情列表 - 获取发送状态
    getTaskDetialSendStatus:(data,options) => {
              options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/daily_task_record/getGenerateStatus', data, options);
    },
}
